// MainLayout menü item'ları için Türkçe → İngilizce label haritası.
//
// Strateji: Menü item'larındaki `label: 'XYZ'` hardcoded Türkçe string'ler
// olduğu için, render sırasında bu map'ten EN karşılığı aranır.
// Eşleşme yoksa orijinal Türkçe label döndürülür (graceful fallback).
//
// Yeni menü item'ı eklerken buraya da EN karşılığı ekle.

const NAV_TR_TO_EN = {
  // ── Cari İşlemleri ───────────────────────────────────────
  'Cari Hesaplar': 'Customers / Suppliers',
  'Cari Hesap Kartı': 'Account Card',
  'Cari Kart': 'Account Card',
  'Potansiyel Cariler': 'Prospects',
  'CRM Pipeline': 'CRM Pipeline',
  'Lead Formu': 'Lead Form',
  'Web Form Embed': 'Web Form Embed',
  'Kaybedilme Nedenleri': 'Lost Reasons',
  'Projeler': 'Projects',
  'eTicaret Siparişleri': 'eCommerce Orders',
  'eTicaret Katalog Embed': 'eCommerce Catalog',
  'Tahsilat Makbuzları': 'Customer Receipts',
  'Tediye Makbuzları': 'Supplier Payments',
  'Alış-Veriş Çekleri': 'Shopping Vouchers',
  'Cari Dekontu': 'Account Voucher',
  'Cari Ekstre': 'Account Statement',

  // ── Banka İşlemleri ─────────────────────────────────────
  'Banka Hesapları': 'Bank Accounts',
  'Banka POS Kartları': 'Bank POS Definitions',
  'POS Slip Tahsilat': 'POS Slip Collection',
  'Firma Kredi Kartları': 'Company Credit Cards',
  'Banka Açılış Fişi': 'Bank Opening Voucher',
  'Banka Alacak Dekontu': 'Bank Credit Voucher',
  'Banka Borç Dekontu': 'Bank Debit Voucher',
  'Banka Virman Dekontu': 'Bank Transfer Voucher',

  // ── Kasa İşlemleri ──────────────────────────────────────
  'Kasa Hareketleri': 'Cash Transactions',
  'Kasa Açılış Fişi': 'Cash Opening Voucher',
  'Kasa Virman Dekontu': 'Cash Transfer Voucher',
  'Gider Fişleri': 'Expense Vouchers',
  'Gider Masraf Kartı': 'Expense Cards',

  // ── Satış ───────────────────────────────────────────────
  'Satış Faturası': 'Sales Invoice',
  'Satış Faturaları': 'Sales Invoices',
  'Satış İade Faturası': 'Sales Return',
  'Satış İade': 'Sales Return',
  'Satış Siparişi': 'Sales Order',
  'Satış Siparişleri': 'Sales Orders',
  'Satış Teklifi': 'Sales Quote',
  'Satış Teklifleri': 'Sales Quotes',
  'Satış İrsaliyesi': 'Sales Waybill',
  'Satış İrsaliyeleri': 'Sales Waybills',
  'Perakende Satış': 'Retail Sales (POS)',
  'Perakende Mağaza': 'Retail Store',
  'Mağaza': 'Store',

  // ── Alış ────────────────────────────────────────────────
  'Alış Faturası': 'Purchase Invoice',
  'Alış Faturaları': 'Purchase Invoices',
  'Alış İade Faturası': 'Purchase Return',
  'Alış Siparişi': 'Purchase Order',
  'Alış Siparişleri': 'Purchase Orders',
  'Alış Teklifi': 'Purchase Quote',
  'Alış Teklifleri': 'Purchase Quotes',
  'Alış İrsaliyesi': 'Purchase Waybill',
  'Alış İrsaliyeleri': 'Purchase Waybills',
  'Teklif Talebi (RFQ)': 'RFQ',
  'RFQ': 'RFQ',
  'Sipariş Önerileri': 'Reorder Suggestions',
  'BA/BS Form Raporu': 'BA/BS Report',

  // ── Stok İşlemleri ──────────────────────────────────────
  'Stoklar': 'Stocks',
  'Stok / Ürünler': 'Stocks / Products',
  'Stok Seri Tanımları': 'Stock Series',
  'Renk / Beden Sihirbazı': 'Color / Size Wizard',
  'Depo Nakil Fişi': 'Warehouse Transfer',
  'Depo Nakil Fişleri': 'Warehouse Transfers',
  'Stok Sayım': 'Stock Count',
  'Sayım Fazlası Fişleri': 'Count Surplus Vouchers',
  'Sayım Eksiği Fişleri': 'Count Deficit Vouchers',
  'Fire / Zayi Fişi': 'Wastage Voucher',
  'Stok Operasyon Fişi': 'Stock Operation Voucher',

  // ── Çek / Senet ─────────────────────────────────────────
  'Çek Kartı (Alınan)': 'Check (Received)',
  'Çek Kartı (Verilen)': 'Check (Issued)',
  'Senet Kartı (Alınan)': 'Note (Received)',
  'Senet Kartı (Verilen)': 'Note (Issued)',
  'Çek / Senet': 'Checks / Notes',

  // ── Personel / Plasiyer ─────────────────────────────────
  'Personel': 'Personnel',
  'Personel Tanıtım Kartı': 'Personnel Card',
  'Plasiyer Rotaları': 'Sales Routes',
  'Plasiyer Günlüğü': 'Sales Diary',
  'Komisyon / Prim Raporu': 'Commission Report',
  'Hakediş': 'Earnings',
  'Randevu / Ajanda': 'Appointments / Calendar',

  // ── Raporlar ────────────────────────────────────────────
  'Raporlar': 'Reports',
  'Stok Raporları': 'Stock Reports',
  'Satış Raporları': 'Sales Reports',
  'Alış Raporları': 'Purchase Reports',
  'Cari Raporları': 'Account Reports',
  'Kasa Raporları': 'Cash Reports',
  'Banka Raporları': 'Bank Reports',
  'Personel Raporları': 'Personnel Reports',
  'Satış Hedefleri': 'Sales Targets',

  // ── Program Tanımları ───────────────────────────────────
  'Ayarlar': 'Settings',
  'Fiyat Tanımları': 'Price Definitions',
  'Yer Tanımları': 'Locations',
  'Çalışma Dönemleri': 'Fiscal Periods',
  'Aboneliğim': 'My Subscription',
  'Kullanıcılar': 'Users',
  'Roller ve İzinler': 'Roles & Permissions',
  'Depo Tanıtım Kartı': 'Warehouses',
  'Şube Tanıtım Kartı': 'Branches',
  'Şubeler': 'Branches',
  'Depolar': 'Warehouses',
  'Kasa Tanıtım Kartı': 'Cash Registers',
  'Platform / Kargo': 'Platform / Shipping',
  'Departman × Modül': 'Department × Module',
  'Özel Alanlar': 'Custom Fields',
  'İşlem Geçmişi (LOG)': 'Audit Log',
  'İşlem Geçmişi': 'Audit Log',

  // ── e-Belge ─────────────────────────────────────────────
  'e-Belge Yönetimi': 'e-Document Management',
  'Giden Faturalar': 'Outgoing Invoices',
  'Gelen Faturalar': 'Incoming Invoices',
  'GİB Etiketleri': 'Tax Authority Labels',

  // ── Vendor Paneli ───────────────────────────────────────
  'Ana Sayfa': 'Dashboard',
  'Vendor Dashboard': 'Vendor Dashboard',
  'Firmalar': 'Companies',
  'Tickets': 'Tickets',
  'Mesajlar': 'Messages',
  'Planlar': 'Plans',
  'Team': 'Team',
  'Settings': 'Settings',

  // ── Üst Menü Grupları ───────────────────────────────────
  'Stok İşlemleri': 'Stock Operations',
  'Cari İşlemleri': 'Account Operations',
  'Banka İşlemleri': 'Bank Operations',
  'Kasa İşlemleri': 'Cash Operations',
  'Satış İşlemleri': 'Sales Operations',
  'Alış İşlemleri': 'Purchase Operations',
  'Çek / Senet İşlemleri': 'Check / Note Operations',
  'Personel İşlemleri': 'Personnel Operations',
  'Program Tanımları': 'Program Definitions',
  'Onay Bekleyenler': 'Pending Approvals',
  'Onaylar': 'Approvals',

  // ── Diğer ───────────────────────────────────────────────
  'Pergole Eklentisi': 'Pergola Add-on',
  'Persan Tablo Şablonları': 'Pergola Templates',
  'Dashboard': 'Dashboard',
  'Bildirimler': 'Notifications',

  // ── pageTitles özel (sayfa başlığı/breadcrumb) ──────────
  'Cari İşlemler': 'Account Operations',
  'Çek-Senet İşlemleri': 'Check / Note Operations',
  'Kur Takibi': 'Exchange Rates',
  'Hesap Planı (TDHP)': 'Chart of Accounts',
  'Hesap Eşleme Tablosu': 'Account Mapping',
  'Muhasebe': 'Accounting',
  'Belge Onayları': 'Document Approvals',
  'Bekleyen Onaylar': 'Pending Approvals',
  'Onaylanan Belgeler': 'Approved Documents',
  'AI Veri Analizi': 'AI Data Analysis',
  'Stok Raporları': 'Stock Reports',
  'Cari Raporları': 'Account Reports',
  'Banka Raporları': 'Bank Reports',
  'Personel Raporları': 'Personnel Reports',
  'Fatura Raporları': 'Invoice Reports',
  'Alınan Teklifler': 'Quotes Received',
  'Verilen Teklifler': 'Quotes Issued',
  'Alınan Siparişler': 'Orders Received',
  'Verilen Siparişler': 'Orders Issued',
  'Barkod Etiket Dökümü': 'Barcode Label Print',
  'Etiket Şablonları': 'Label Templates',
  'Etiket Tasarım': 'Label Designer',
  'E-Belge Yönetimi': 'e-Document Management',
  'Gelen Fatura (e-Belge)': 'Incoming Invoice (e-Doc)',
  'Giden Fatura (e-Belge)': 'Outgoing Invoice (e-Doc)',
  'Gelen İrsaliye (e-Belge)': 'Incoming Waybill (e-Doc)',
  'Giden İrsaliye (e-Belge)': 'Outgoing Waybill (e-Doc)',
  'Cari Açılış Fişi': 'Account Opening Voucher',
  'Cari Borç Dekontu': 'Account Debit Voucher',
  'Cari Alacak Dekontu': 'Account Credit Voucher',
  'Cari Virman Dekontu': 'Account Transfer Voucher',
  'Cari Tahsilat Makbuzu': 'Customer Receipt',
  'Personel Alacak Dekontu': 'Personnel Credit Voucher',
  'Personel Borç Dekontu': 'Personnel Debit Voucher',
  'Satış / İade Faturaları': 'Sales / Returns',
  'Alış / İade Faturaları': 'Purchases / Returns',
  'Günlük Saha Ziyaretleri': 'Daily Field Visits',
  'Prim / Hakediş Raporu': 'Commission / Earnings Report',
  'Alış Veriş Çekleri': 'Shopping Vouchers',
  'Müşteri Firmalar': 'Customer Companies',
  'Lead\'ler & Pipeline': 'Leads & Pipeline',
  'Destek Talepleri': 'Support Tickets',
  'Müşteri Mesajları': 'Customer Messages',
  'Abonelik Planları': 'Subscription Plans',
  'Ödeme Yöntemleri': 'Payment Methods',
  'Raporlar & Analitik': 'Reports & Analytics',
  'Kullanıcı Tanımları': 'User Definitions',
  'Vendor Ayarları': 'Vendor Settings',
  'Müşteri Detayı': 'Customer Detail',
  'Sayım Fazlası Fişleri': 'Count Surplus Vouchers',
  'Sayım Eksiği Fişleri': 'Count Deficit Vouchers',
  'Web Lead Form': 'Web Lead Form',
  'E-Ticaret Siparişleri': 'eCommerce Orders',
  'E-Ticaret Katalog Kodu': 'eCommerce Catalog Embed',
  'BA / BS Formu': 'BA / BS Form',
  'RFQ (Toplu Teklif)': 'RFQ (Bulk Quote)',
  'Platform / Kargo Tanımları': 'Platform / Shipping Definitions',
};

// Render sırasında çağrılır: TR ise label aynen, EN ise eşleşme döndürür
export function navLabel(label, lang) {
  if (!label) return label;
  if ((lang || 'tr').startsWith('tr')) return label;
  return NAV_TR_TO_EN[label] || label;
}

export default NAV_TR_TO_EN;
